import { render, staticRenderFns } from "./SuspendedPassengers.html?vue&type=template&id=640e9633&scoped=true&external"
import script from "./SuspendedPassengers.js?vue&type=script&lang=js&external"
export * from "./SuspendedPassengers.js?vue&type=script&lang=js&external"
import style0 from "./SuspendedPassengers.vue?vue&type=style&index=0&id=640e9633&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640e9633",
  null
  
)

export default component.exports